import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { sourceMedia } from '@/data/media-manifest'

export function ProductMedia({ path, altKey, eager = false, className = '' }: { path: string; altKey: string; eager?: boolean; className?: string }) {
  const { t } = useTranslation('common')
  const [failed, setFailed] = useState(false)
  const media = sourceMedia.find(item => item.path === path)
  return <figure className={`product-media ${className}`}>
    {media && !failed
      ? <img src={media.path} width={media.width} height={media.height} alt={t(altKey)} loading={eager ? 'eager' : 'lazy'} decoding="async" onError={() => setFailed(true)} />
      : <p role="status">{t('catalog.mediaUnavailable')}</p>}
  </figure>
}
